  
 
import React from 'react';
import moment from 'moment';

import Text from 'v3/components/Text';

import { cooperplaceApi } from 'services/api';

export async function renewLoad({
  setConfirmButtonDisabled,
  setSuccessfullyRenovated,
  reasonSelected,
  newDueDate,
  snackbar,
  preLoad,
  setLoading,
  selectedNewBranch,
  setNewBranchError,
  isBranchActive,
}) {
  if (!preLoad?.id) {
    return;
  }

  let errorMessage = '';
  if (!moment(newDueDate, 'YYYY-MM-DDTHH:mm').isValid()) {
    errorMessage = 'Por favor, selecione uma data válida.';
  }

  if (!isBranchActive && !selectedNewBranch?.id) {
    errorMessage = 'Por favor, selecione uma filial.';
    setNewBranchError(errorMessage);
  }

  if (errorMessage) {
    snackbar.show(<Text>{errorMessage}</Text>, {
      type: 'error',
    });
    setConfirmButtonDisabled(false);
    return;
  }
  try {
    setLoading(true);
    const response = await cooperplaceApi.post(`loads/${preLoad?.id}/renew`, {
      cancelRefLoad: preLoad?.travel ? 0 : 1,
      deletedReason: preLoad?.travel ? '' : reasonSelected.value,
      dueDate: moment(newDueDate, 'YYYY-MM-DDTHH:mm'),
      branchOfficeId: selectedNewBranch?.id,
    });

    setConfirmButtonDisabled(false);
    setSuccessfullyRenovated(true);

    return response.data;
  } catch (err) {

    const messageError = err.response?.data?.message || 'Não foi possível renovar a pré carga';

    snackbar.show(<Text>{messageError}</Text>, {
      type: 'error',
    });

    setConfirmButtonDisabled(false);
  } finally {
    setLoading(false);
  }
}
